import React from "react";
import Dialog from "@material-ui/core/Dialog";
import WebForm from "./WebPreviewDetail";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";
import {withStyles} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Typography from "@material-ui/core/Typography";
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import Grid from "@material-ui/core/Grid";
import ButtonAtm from "../../../../../atomic/Button/Button";
import {Link} from "react-router-dom";
import Slide from '@material-ui/core/Slide';
import {WEB_EDIT_SHORT} from "../../../../../../constants/appUrls.constants";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {InputLabel} from "@material-ui/core";

let t = null;

const THEMES = [
    { id: 1, label: 'Default Template',  name: 'Boutique', value: 'default' },
    { id: 2, label: 'Template 2',        name: 'Stork',    value: 'theme2'  },
    { id: 3, label: 'Template 3',        name: 'Oscar',    value: 'theme3'  },
    { id: 4, label: 'Template 4',        name: 'Qlusive',  value: 'theme4'  },
    { id: 5, label: 'Template 5',        name: 'Valencia', value: 'theme5'  },
    { id: 6, label: 'Template 6',        name: 'Solene',   value: 'theme6'  },
];

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class WebPreviewDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTheme: props.currentTemplate?.folder_name || 'default'
        };
        t = props.t;
    }

    handleThemeChange = (e) => {
        this.setState({ selectedTheme: e.target.value });
    };

    componentDidUpdate(prevProps) {
        if (prevProps?.currentTemplate !== this.props?.currentTemplate) {
            this.setState({
                selectedTheme: this.props.currentTemplate?.folder_name || 'default'
            });
        }
    }

    render() {
        const isZoomed = window.innerWidth >= 960 && window.innerWidth <= 1600;
        const menuTransform = isZoomed ? 'translateX(325px)' : undefined;

        return (
            <Dialog className="web-preview-dialog"
                    TransitionComponent={Transition}
                    onClose={this.props.handlePreviewClose}
                    fullScreen
                    aria-labelledby="customized-dialog-title"
                    open={this.props.open_preview}
            >
                <DialogTitle className="red-bottom-border" id="rate-plan" onClose={this.props.handlePreviewClose}>
                    <Grid container spacing={3} alignItems="center" style={{ paddingRight: 56 }}>
                        <Grid item xs={4} md={2}>
                            <div className="d-grid">
                                <Link
                                    className={"site-edit-btn"}
                                    to={WEB_EDIT_SHORT + this.props.webId}
                                >
                                    {t('btn-edit')}
                                </Link>
                            </div>
                        </Grid>

                        <Grid item xs={4} md={2}>
                            <ButtonAtm
                                className={"site-setup-btn"}
                                fullwidth={true}
                                buttontext={t('btn-setup')}
                                onClick={this.props.openSetup}
                            />
                        </Grid>

                        {this.props.userEmail?.endsWith('@extranetwork.com') && (
                            <Grid item style={{ marginLeft: 'auto' }}>
                                <FormControl variant="outlined" size="small" className="theme-select-form-control">
                                    <InputLabel id="theme-select-label">{t('enw-template-title')}</InputLabel>
                                    <Select
                                        labelId="theme-select-label"
                                        label="Template"
                                        value={this.state?.selectedTheme}
                                        onChange={this.handleThemeChange}
                                        style={{ minWidth: 210, background: '#fff', fontSize: 16 }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    transform: menuTransform
                                                }
                                            }
                                        }}
                                    >
                                        {THEMES.map(theme => (
                                            <MenuItem key={theme.value} value={theme.value}>
                                                {theme.id}. {theme.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <WebForm
                        handleClickOpen={this.props.handleClickOpenPreview}
                        handlePreviewClose={this.props.handlePreviewClose}
                        token={this.props.token}
                        webId={this.props.webId}
                        webDefaultLang={this.props.webDefaultLang}
                        frameReload={this.props.frameReload}
                        selectedTheme={this.state.selectedTheme}
                        currentTemplate={this.props.currentTemplate?.folder_name || 'default'}
                    />
                </DialogContent>
                <style>
                    {`
                        .theme-select-form-control {
                            margin-top:0px!important;
                        }
                    `}
                </style>
            </Dialog>
        );
    }
}

export default compose(withTranslation('common'))(WebPreviewDialog);
